<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" labelName="userName"
                               labelValue="id" title="选择用户" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
<!--              <el-form-item label="题目">-->
<!--                  <el-input  v-model="queryForm.exerciseId"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduExerciseRecordList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addEduExerciseRecord"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editEduExerciseRecord(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduExerciseRecord(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshEduExerciseRecordList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduExerciseRecordList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="exerciseId"
        label="题目"
        width="180"
      >
          <template slot-scope="scope">
              <span v-html="scope.row.exercise.exerciseName"></span>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="isRight"
        label="是否正确"
        width="180"
      >
          <template slot-scope="scope">
              <span v-if="scope.row.isRight == 1">正确</span>
              <span v-else>错误</span>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
<!--            <div @click="checkEduExerciseRecord(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Eye24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">查看</span>-->
<!--            </div>-->
<!--            <div @click="editEduExerciseRecord(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteEduExerciseRecord(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduExerciseRecordStates[eduExerciseRecordState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="eduExerciseRecord"
          ref="eduExerciseRecordForm"
          :rules="rules"
          label-width="80px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="用户"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduExerciseRecord.userId"-->
<!--              :disabled="eduExerciseRecordState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" labelName="userName" :disabled="eduExerciseRecordState == 'check'"
                           labelValue="id" title="选择用户" :value="eduExerciseRecord.userId" :limit='1' size='small' placeholder='请选择用户'
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
<!--          <el-form-item-->
<!--            label="题目id"-->
<!--            prop="exerciseId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="eduExerciseRecord.exerciseId"-->
<!--              :disabled="eduExerciseRecordState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="是否正确"
            prop="isRight"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="eduExerciseRecord.isRight"-->
<!--              :disabled="eduExerciseRecordState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                size="small"
                style="width: 177px;"
                v-model="eduExerciseRecord.isRight"
                :disabled="eduExerciseRecordState == 'check'"
              >
                <el-option
                  label="是"
                  :value="1"
                ></el-option>
                  <el-option
                      label="否"
                      :value="0"
                  ></el-option>
              </el-select>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduExerciseRecordState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduExerciseRecordList();
                    this.getEduExerciseRecordList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduExerciseRecordList();
                    this.getEduExerciseRecordList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     id: '', //
                     userId: '', //用户
                     exerciseId: '', //题目id
                     isRight: '', //是否正确
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                eduExerciseRecordState: 'add',
                eduExerciseRecordStates: {
                    add: '新建习题分析',
                    check: '查看习题分析',
                    edit: '修改习题分析'
                },

                multipleSelection: [],
                eduExerciseRecordList: [],
                eduExerciseRecord: {
                    id: '', //
                    userId: '', //用户
                    exerciseId: '', //题目id
                    isRight: '', //是否正确
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    exerciseId: [{ required: true, message: '题目id不能为空', trigger: 'blur' }],
                    isRight: [{ required: true, message: '是否正确不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {

        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getValueUser(value){
                this.eduExerciseRecord.userId = value;
            },
            getSearchValueUser(value){
                this.queryForm.userId = value;
            },
            init(id){
                this.queryForm.exerciseId = id;
                this.eduExerciseRecord.exerciseId = id;
                this.getEduExerciseRecordList();
            },
            resetEduExerciseRecordList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduExerciseRecordList = [];
            },
            resetDialog() {
                this.eduExerciseRecordState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户
                      exerciseId: this.queryForm.exerciseId, //题目id
                      isRight: '', //是否正确
                };
                this.getEduExerciseRecordList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduExerciseRecord = {
                      id: '', //
                      userId: '', //用户
                      exerciseId: this.eduExerciseRecord.exerciseId, //题目id
                      isRight: '', //是否正确
                };
            },
            submitForm() {
                if (this.eduExerciseRecordState == 'add') {
                    this.$refs.eduExerciseRecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/exerciserecord/add`,{ ...this.eduExerciseRecord }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduExerciseRecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduExerciseRecordState == 'edit') {
                    this.$refs.eduExerciseRecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/exerciserecord/edit`,{ ...this.eduExerciseRecord }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduExerciseRecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduExerciseRecord() {
                this.showDialog = true;
                this.eduExerciseRecordState = 'add';
            },
            checkEduExerciseRecord(eduExerciseRecordId) {
                console.log(eduExerciseRecordId);
                this.currentEduExerciseRecordId = eduExerciseRecordId;

                this.getEduExerciseRecordById();
                this.showDialog = true;
                this.eduExerciseRecordState = 'check';
            },
            editEduExerciseRecord(eduExerciseRecordId) {
                console.log('eduExerciseRecord', eduExerciseRecordId);
                if (eduExerciseRecordId) {
                    this.currentEduExerciseRecordId = eduExerciseRecordId;
                    this.getEduExerciseRecordById();
                } else {
                    this.eduExerciseRecord = { ...this.eduExerciseRecord, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduExerciseRecordState = 'edit';
            },
            deleteEduExerciseRecord(eduExerciseRecordId) {
                let ids = '';
                if (eduExerciseRecordId) {
                    ids = eduExerciseRecordId;
                } else {
                    ids = this.multipleSelection.map((eduExerciseRecord) => eduExerciseRecord.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/exerciserecord/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduExerciseRecordList();
                                this.getEduExerciseRecordList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduExerciseRecordList() {
                this.resetEduExerciseRecordList();
                this.getEduExerciseRecordList();
            },
            getEduExerciseRecordList(query = {}) {
                this.loading = true;
                get(`/edu/exerciserecord/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduExerciseRecordList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduExerciseRecordById() {
                get(`/edu/exerciserecord/get`,{ id: this.currentEduExerciseRecordId }).then((res) =>{
                    if(res.success){
                      this.eduExerciseRecord = { ...this.eduExerciseRecord, ...res.eduExerciseRecord };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduExerciseRecordList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/exerciserecord/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/exerciserecord/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/exerciserecord/importData`,formData);
              this.refreshEduExerciseRecordList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduExerciseRecordList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduExerciseRecordList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>